import React from 'react';
import { Row, Col, Card, Table, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaFileInvoiceDollar, FaClock, FaCheckCircle, FaArrowRight } from 'react-icons/fa';

function Dashboard() {
  // Mock data - replace with actual data fetching
  const stats = [
    {
      title: 'Total Outstanding',
      value: '$12,450',
      icon: <FaFileInvoiceDollar className="text-primary" size={24} />,
      change: '+4.75%',
      isPositive: false
    },
    {
      title: 'Pending Invoices',
      value: '8',
      icon: <FaClock className="text-warning" size={24} />,
      change: '-1.5%',
      isPositive: true
    },
    {
      title: 'Completed Invoices',
      value: '24',
      icon: <FaCheckCircle className="text-success" size={24} />,
      change: '+2.3%',
      isPositive: true
    }
  ];

  const recentInvoices = [
    {
      id: 'INV-001',
      client: 'Acme Construction',
      jobSite: '123 Main St',
      amount: '$2,400',
      status: 'Pending',
      date: '2024-05-22'
    },
    {
      id: 'INV-002',
      client: 'BuildRight Inc',
      jobSite: '456 Oak Ave',
      amount: '$1,850',
      status: 'Paid',
      date: '2024-05-21'
    },
    {
      id: 'INV-003',
      client: 'Metro Builders',
      jobSite: '789 Pine St',
      amount: '$3,200',
      status: 'Pending',
      date: '2024-05-20'
    }
  ];

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h3 mb-0">Dashboard</h1>
        <Button
          as={Link}
          to="/invoices/new"
          variant="primary"
          className="d-flex align-items-center"
        >
          Create Invoice
        </Button>
      </div>

      <Row className="g-4 mb-4">
        {stats.map((stat, index) => (
          <Col key={index} md={4}>
            <Card className="h-100">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="rounded-circle p-2 bg-light">{stat.icon}</div>
                  <span className={`text-${stat.isPositive ? 'success' : 'danger'} small`}>
                    {stat.change}
                  </span>
                </div>
                <h3 className="h5 text-secondary mb-1">{stat.title}</h3>
                <h2 className="h3 mb-0">{stat.value}</h2>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Card>
        <Card.Header className="bg-white py-3">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="h5 mb-0">Recent Invoices</h2>
            <Button
              as={Link}
              to="/invoices"
              variant="link"
              className="text-primary d-flex align-items-center p-0"
            >
              View All <FaArrowRight className="ms-2" />
            </Button>
          </div>
        </Card.Header>
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table hover className="mb-0">
              <thead>
                <tr>
                  <th>Invoice #</th>
                  <th>Client</th>
                  <th>Job Site</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {recentInvoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td>
                      <Link to={`/invoices/${invoice.id}`} className="text-primary fw-medium">
                        {invoice.id}
                      </Link>
                    </td>
                    <td>{invoice.client}</td>
                    <td>{invoice.jobSite}</td>
                    <td>{invoice.amount}</td>
                    <td>
                      <span className={`status-badge ${invoice.status.toLowerCase()}`}>
                        {invoice.status}
                      </span>
                    </td>
                    <td>{invoice.date}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Dashboard; 